import React, { useContext } from 'react';
import { AuthContext } from '../../context/auth';;
import Header from '../../components/Header';
import MenuActividadEconomica from '../../components/hacienda/actividadEconomica/menuActividadEconomica';
import TablaComercioDeclarar from '../../components/hacienda/actividadEconomica/tablaComerciosDeclarar';
import Footer from '../../components/Footer';


function ComerciosDeclarar() {

  const { user } = useContext(AuthContext);
  let op = require('../../../src/modulos/datos');

  return (

    user && (

      <div style={{ height: "100vh", padding: 0 }}>
        <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
          <Header />
        </div>
        <div className="row col-md-12" style={{ height: "85%", padding: 0, margin: 0 }}>
          <div className="col-md-12" style={{ height: "100%", padding: 0 }}>
            <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
              <MenuActividadEconomica />
            </div>
            <div className="col-md-12" style={{ height: "90%", padding: 0 }}>
              <TablaComercioDeclarar />
            </div>
          </div>
        </div>
        <div  className="col-md-12" style={{ height: "5%", padding: 0 }}>
           <Footer />
        </div>
      </div>

    )

  );
}


export default ComerciosDeclarar;
